import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5d64eda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-container" }


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const routes = [
  {route: '/about', text: 'About me'},
  {route: '/resources', text: 'Learning ressources'},
  {route: '/home', text: 'Home'}
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(routes, (route) => {
        return _createElementVNode("li", {
          key: route.route
        }, [
          _createVNode(_component_router_link, {
            to: route.route
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(route.text), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ])
      }), 64))
    ])
  ]))
}
}

})